package ai.jessie.shared.invoices

import kotlinx.serialization.Serializable

// UC-014 / FR-014. Statuses are DRAFT, READY, SENT, PAID and CANCELLED; dates are ISO dates in the
// organisation's time zone. The server decides every transition; the client only proposes one.

// B5: expectedStatus is the status the member saw (A10). `date` is the dispatch date for SENT and
// the payment date for PAID; absent means today in the organisation's time zone (A2, A4).
// `cancellationReason` is required for CANCELLED only (A5).
@Serializable
data class InvoiceTransitionRequest(
    val expectedStatus: String,
    val targetStatus: String,
    val date: String? = null,
    val cancellationReason: String? = null,
)

// One recorded transition (BR-087). actorName is absent for Jessie dispatch (source SYSTEM) and
// for a member without a display name. `date` is the recorded dispatch or payment date.
@Serializable
data class InvoiceStateEventResponse(
    val previousStatus: String,
    val newStatus: String,
    val source: String,
    val actorName: String?,
    val occurredAt: String,
    val date: String? = null,
)

// Step 4: the current invoice, the next statuses this actor may select and the ordered history
// (B9). currentDate is today in the organisation's time zone, the dispatch and payment default.
@Serializable
data class InvoiceProgressResponse(
    val invoice: InvoiceResponse,
    val permittedTransitions: List<String>,
    val history: List<InvoiceStateEventResponse>,
    val currentDate: String,
)
